import { render, staticRenderFns } from "./OsmMap.vue?vue&type=template&id=736f4d82"
import script from "./OsmMap.vue?vue&type=script&lang=js"
export * from "./OsmMap.vue?vue&type=script&lang=js"
import style0 from "./OsmMap.vue?vue&type=style&index=0&id=736f4d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports